import React from "react";
import "./Media_Community_Policy.css";
import "../../Homepage/LegalPageTheme.css";
import HeroNav from "../../Homepage/HeroNav";
import LegalLinks from "../../Homepage/LegalLinks";

const Media_Community_Policy = ({ onClose }) => {
    return (
        <div className="MCP_Page">
            <HeroNav compact />

            {/* Page Content */}
            <div className="MCP_Body">
                <h1 className="MCP_Title">BOLO-INDIA-MEDIA COMMUNITY GUIDELINES</h1>
                <br />
                <h3 className="MCP_Updated">Effective Date: August 6, 2026</h3>
                <h3 className="MCP_Updated">Last updated: August 6, 2026</h3>
                <p style={{ fontWeight: 700, color: "#1e1e1e" }}>
                    Speak. Share. Connect. Responsibly.
                </p>
                <p>
                    Bolo-India-Media is built to give people a place to express
                    themselves, share their stories, discover ideas, build communities and
                    connect with people across India.
                </p>
                <p>
                    India is diverse. We speak different languages, follow different
                    cultures and traditions, hold different beliefs and have different
                    opinions. That diversity is something we value.{" "}
                </p>
                <p>
                    We want Bolo-India-Media to be a platform where people can{" "}
                    <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                        speak freely, disagree respectfully and participate safely.{" "}
                    </span>
                </p>
                <p>
                    These Community Guidelines explain what is and is not permitted on
                    Bolo-India.
                </p>

                <p>
                    By using Bolo-India-Media, you agree to follow these Guidelines
                    together with our Terms of Use, Privacy Policy, Copyright & Music
                    Policy and other applicable policies.
                </p>

                <h2>1. OUR COMMUNITY PRINCIPLES </h2>
                <p>Bolo-India-Media is guided by five principles.</p>
                <ul>
                    <li style={{ fontWeight: 700, color: "#1e1e1e" }}>
                        Freedom of Expression
                    </li>
                    <p>
                        People should be able to express opinions, share experiences, debate
                        ideas and participate in public conversations.
                    </p>
                    <p>
                        We will not remove content simply because it is unpopular, critical
                        or controversial.
                    </p>
                    <li style={{ fontWeight: 700, color: "#1e1e1e" }}>Safety</li>
                    <p>
                        Freedom of expression should not be used to seriously threaten,
                        exploit or harm others.
                    </p>
                    <p>
                        We apply heightened protections where children, sexual exploitation,
                        credible threats or other serious safety risks are involved.
                    </p>
                    <li style={{ fontWeight: 700, color: "#1e1e1e" }}>Respect </li>
                    <p>
                        Disagreement is part of conversation. Personal attacks, targeted
                        harassment, exploitation and intimidation are not.
                    </p>
                    <li style={{ fontWeight: 700, color: "#1e1e1e" }}>Authenticity </li>
                    <p>
                        People should be able to understand who and what they are
                        interacting with.
                    </p>
                    <p>
                        Fraud, deceptive impersonation, manipulated identities and
                        coordinated Platform abuse undermine trust and nis not allowed.
                    </p>
                    <li style={{ fontWeight: 700, color: "#1e1e1e" }}>Responsibility </li>
                    <p>
                        Every user is responsible for the content they create, upload and
                        share.
                    </p>
                </ul>

                <h2>2. THESE GUIDELINES APPLY EVERYWHERE </h2>
                <p>
                    These Guidelines apply to content and activity across
                    Bolo-India-Media, including:
                    <ul>
                        <li>posts;</li>
                        <li>photographs;</li>
                        <li>short videos;</li>
                        <li>long-form videos;</li>
                        <li>stories;</li>
                        <li>livestreams;</li>
                        <li>audio and music;</li>
                        <li>comments;</li>
                        <li>reactions;</li>
                        <li>profile photographs;</li>
                        <li>usernames;</li>
                        <li>bios;</li>
                        <li>groups and communities;</li>
                        <li>direct messages, where applicable;</li>
                        <li>advertisements and promotions; and</li>
                        <li>AI-generated or digitally manipulated content.</li>
                    </ul>
                </p>

                <h2>3. FOLLOW THE LAW</h2>
                <p>
                    Bolo-India-Media operates in India and users must comply with
                    applicable law.
                </p>
                <p>
                    Do Not use Bolo-India-Media to create, upload, publish, promote,
                    distribute or facilitate unlawful activity or content.
                </p>
                <p>
                    Where required under applicable Indian law, a valid court order or
                    legally binding governmental direction, Bolo-India-Media may remove or
                    disable access to content and take appropriate action against
                    accounts.
                </p>

                <h2>4. CHILD SAFETY</h2>
                <p>Protecting children is one of our highest priorities.</p>
                <p>
                    Bolo-India-Media has{" "}
                    <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                        zero tolerance for child sexual abuse material (CSAM), grooming or
                        sexual exploitation of children.
                    </span>
                </p>
                <p>
                    You must never post, request, distribute, promote or facilitate:
                    <ul>
                        <li>sexual images or videos involving children;</li>
                        <li>sexualised depictions of minors;</li>
                        <li>grooming;</li>
                        <li>sexual solicitation of minors;</li>
                        <li>child exploitation;</li>
                        <li>sexual trafficking involving children;</li>
                        <li>links to child sexual abuse material;</li>
                        <li>attempts to buy, sell or exchange such material; or</li>
                        <li>
                            AI-generated or digitally manipulated sexual content depicting or
                            purporting to depict minors.
                        </li>
                    </ul>
                </p>
                <p>Such content will be removed.</p>
                <p>
                    Accounts involved in serious child sexual exploitation may be
                    permanently banned.
                </p>
                <p>
                    Information may be preserved and reported to appropriate authorities
                    where required by applicable law.
                </p>

                <h2>5. NUDITY AND SEXUALLY EXPLICIT CONTENT </h2>
                <p>
                    Bolo-India-Media is intended for a broad community. We do not permit
                    pornography or explicit sexual activity.
                </p>
                <p>
                    Content that may be removed includes:
                    <ul>
                        <li>explicit sexual activity;</li>
                        <li>pornography;</li>
                        <li>sexual solicitation;</li>
                        <li>sexual exploitation;</li>
                        <li>voyeuristic sexual content;</li>
                        <li>non-consensual intimate imagery;</li>
                        <li>explicit sexual deepfakes; and</li>
                        <li>
                            other sexually explicit content prohibited by our policies or
                            applicable law.
                        </li>
                    </ul>
                    <p>Context matters.</p>
                    <p>
                        Content involving breastfeeding, childbirth, medical education,
                        health awareness, art, documentary reporting or other legitimate
                        contexts may or may not be permitted or appropriately restricted
                        depending on the circumstances.
                    </p>
                </p>

                <h2>6. NON-CONSENSUAL INTIMATE IMAGES</h2>
                <p>
                    Never share someone's intimate images or videos without their consent.
                </p>
                <p>
                    This includes:
                    <ul>
                        <li>revenge pornography;</li>
                        <li>leaked intimate photographs;</li>
                        <li>hidden-camera sexual recordings;</li>
                        <li>manipulated intimate photographs;</li>
                        <li>AI-generated sexual deepfakes; and</li>
                        <li>threats to publish intimate content.</li>
                    </ul>
                    <p>
                        We may remove such content, restrict or terminate accounts, and
                        escalate serious matters where appropriate.
                    </p>
                </p>

                <h2>7. VIOLENCE AND THREATS</h2>
                <p>
                    You may discuss difficult events, crime, conflict and violence. You
                    will not use Bolo India-Media to credibly threaten or organise serious
                    violence.
                </p>
                <p>
                    We prohibit:
                    <ul>
                        <li>
                            credible threats to kill or seriously injure another person;
                        </li>
                        <li>encouragement of imminent violence;</li>
                        <li>planning or coordinating violent attacks;</li>
                        <li>targeted calls for violence; and</li>
                        <li>content facilitating serious violent activity.</li>
                    </ul>
                    <p>
                        Where we believe there is a credible and imminent threat to
                        someone's life or physical safety, we may take urgent action and
                        cooperate with appropriate authorities as permitted or required by
                        law.
                    </p>
                </p>

                <h2>8. GRAPHIC OR DISTURBING CONTENT </h2>
                <p>
                    Some graphic material can have legitimate news, documentary,
                    educational or public-interest value.
                </p>
                <p>
                    For example, content may document:
                    <ul>
                        <li>accidents;</li>
                        <li>natural disasters;</li>
                        <li>wars;</li>
                        <li>crime;</li>
                        <li>medical procedures;</li>
                        <li>human-rights violations; or</li>
                        <li>important news events.</li>
                    </ul>
                    <p>
                        Depending on context, we may allow such content with a warning,
                        restrict its recommendation or limit it to appropriate audiences.
                    </p>
                    <p>
                        Content whose principal purpose is prohibited sadistic celebration
                        or glorification of extreme violence will be removed.
                    </p>
                </p>

                <h2>9. TERRORISM AND VIOLENT EXTREMISM</h2>
                <p>
                    Bolo-India-Media must not be used to support terrorist activity or
                    organisations prohibited under applicable Indian law.
                </p>
                <p>
                    We prohibit content intended to facilitate prohibited activities such
                    as:
                    <ul>
                        <li>terrorist recruitment;</li>
                        <li>planning attacks;</li>
                        <li>operational instructions;</li>
                        <li>unlawful fundraising;</li>
                        <li>material support; or</li>
                        <li>
                            propaganda intended to promote prohibited terrorist activity.
                        </li>
                    </ul>
                    <p>
                        News reporting, documentary material, academic discussion,
                        historical information and counter speech may be treated differently
                        depending on context and applicable law.{" "}
                    </p>
                </p>

                <h2>10. HATEFUL CONDUCT</h2>
                <p>
                    India is home to extraordinary social, cultural, linguistic and
                    religious diversity.
                </p>
                <p>
                    Bolo-India-Media does not permit serious attacks against people based
                    on protected characteristics where such conduct violates our policies
                    or applicable law.
                </p>
                <p>
                    We prohibit content such as:
                    <ul>
                        <li>calls for violence against a protected group;</li>
                        <li>severe dehumanising attacks;</li>
                        <li>
                            encouragement of serious harm against people because of a
                            protected characteristic; and
                        </li>
                        <li>celebration of violence against protected groups.</li>
                    </ul>
                    <p>
                        However, users may debate, discuss or criticise:
                        <ul>
                            <li>religions;</li>
                            <li>political ideologies;</li>
                            <li>institutions;</li>
                            <li>social practices;</li>
                            <li>public policies;</li>
                            <li>governments;</li>
                            <li>organisations; and</li>
                            <li>ideas.</li>
                        </ul>
                    </p>
                </p>
                <p>
                    Criticism of an{" "}
                    <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                        idea, institution or ideology
                    </span>{" "}
                    is not automatically an attack against the{" "}
                    <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                        {" "}
                        people associated with it.{" "}
                    </span>
                </p>

                <h2>11. HARASSMENT AND BULLYING </h2>
                <p>
                    People will disagree on Bolo India. Strong criticism is not
                    automatically harassment.
                </p>
                <p>
                    However, we may take action against:
                    <ul>
                        <li>serious targeted harassment;</li>
                        <li>credible threats;</li>
                        <li>sexual harassment;</li>
                        <li>
                            malicious disclosure of highly sensitive personal information;
                        </li>
                        <li>coordinated harassment;</li>
                        <li>sustained abusive targeting of private individuals; and</li>
                        <li>
                            other conduct intended to seriously intimidate or harm another
                            person.
                        </li>
                    </ul>
                </p>
                <p>
                    Criticism, disagreement, satire and legitimate public debate will not
                    be removed merely because they are uncomfortable or strongly worded.
                </p>

                <h2>12. PUBLIC FIGURES</h2>
                <p>
                    Politicians, celebrities, public officials, business leaders and other
                    public figures are naturally subject to public discussion and
                    criticism.
                </p>
                <p>
                    Users may constructively criticise public figures and their:
                    <ul>
                        <li>decisions;</li>
                        <li>policies;</li>
                        <li>statements;</li>
                        <li>performance;</li>
                        <li>businesses;</li>
                        <li>public conduct; and</li>
                        <li>political positions.</li>
                    </ul>
                </p>
                <p>
                    Threats, unlawful disclosure of private information, abusive language,
                    defaming, sexual exploitation and other serious violations remain
                    prohibited, and actions will be taken as per applicable law. The post
                    will be subjected to review and taken down if classified as violation.
                </p>

                <h2>13. POLITICAL DISCUSSION</h2>
                <p>Bolo-India-Media welcomes lawful political discussion.</p>
                <p>
                    You may:
                    <ul>
                        <li>support a political party;</li>
                        <li>oppose a political party;</li>
                        <li>support or constructively criticise a government;</li>
                        <li>
                            constructively criticise Ministers and elected representatives;
                        </li>
                        <li>discuss public policies which are in the public domain;</li>
                        <li>campaign lawfully;</li>
                        <li>debate elections;</li>
                        <li>express political opinions; and</li>
                        <li>disagree with other users.</li>
                    </ul>
                </p>
                <p>
                    Bolo-India's Community Guidelines are intended to be applied without
                    favouring any political party, ideology or candidate.
                </p>
                <p>
                    Political expression remains subject to the same safety, authenticity
                    and legal standards that apply to other content.
                </p>

                <h2>14. ELECTION INTEGRITY</h2>
                <p>
                    Users must not deliberately deceive people about essential official
                    voting procedures in a manner that could materially interfere with
                    their ability to participate in an election.
                </p>
                <p>
                    This may include deliberately false information about:
                    <ul>
                        <li>official voting dates;</li>
                        <li>polling locations;</li>
                        <li>voter eligibility procedures; or</li>
                        <li>official election processes.</li>
                    </ul>
                </p>
                <p>
                    Fraudulent impersonation of election authorities is prohibited, and
                    actions will be taken as per applicable law. The post will be
                    subjected to review and taken down if classified as violation.
                </p>

                <h2>15. MISINFORMATION</h2>
                <p>
                    People sometimes make mistakes, disagree about facts or interpret
                    events differently.
                </p>
                <p>
                    We do not automatically remove every statement simply because it may
                    be inaccurate or disputed.
                </p>
                <p>
                    Depending on the circumstances, Bolo-India-Media may:
                    <ul>
                        <li>leave content available;</li>
                        <li>provide context;</li>
                        <li>add a label;</li>
                        <li>reduce recommendation;</li>
                        <li>restrict monetisation;</li>
                        <li>direct users towards authoritative information; or</li>
                        <li>
                            remove content where required by applicable law or where it
                            violates a specific safety policy.
                        </li>
                    </ul>
                </p>
                <p>
                    Opinion and factual assertion are not the same thing. Satire and
                    parody should also not automatically be treated as misinformation.
                </p>

                <h2>16. AI-GENERATED CONTENT AND DEEPFAKES</h2>
                <p>
                    Artificial intelligence can be a powerful tool for creativity. Users
                    may create and share AI-generated content subject to these Guidelines
                    and applicable law.
                </p>
                <p>
                    Where required, users must identify or disclose synthetically
                    generated or materially altered content.
                </p>
                <p>
                    Bolo-India-Media may apply labels such as:
                    <ul>
                        <li>AI GENERATED</li>
                        <li>AI MODIFIED</li>
                        <li>or</li>
                        <li>SYNTHETIC MEDIA</li>
                    </ul>
                </p>
                <p>
                    We may remove AI-generated or manipulated content used for prohibited
                    purposes such as:
                    <ul>
                        <li>sexual deepfakes;</li>
                        <li>child sexual content;</li>
                        <li>serious fraudulent impersonation;</li>
                        <li>scams;</li>
                        <li>identity theft;</li>
                        <li>unlawful threats; or</li>
                        <li>other prohibited deception.</li>
                    </ul>
                </p>
                <p>
                    Users must not deliberately remove, conceal or circumvent labels,
                    metadata or technical identifiers required by Bolo-India-Media or
                    applicable law.
                </p>

                <h2>17. IMPERSONATION</h2>
                <p>Be yourself—or make it clear when you are not.</p>
                <p>
                    Do not impersonate another person, organisation, company or public
                    authority in a deceptive manner.
                </p>
                <p>
                    Examples include:
                    <ul>
                        <li>pretending to be a celebrity;</li>
                        <li>impersonating a politician;</li>
                        <li>creating a fake government account;</li>
                        <li>pretending to represent a company;</li>
                        <li>posing as Bolo-India-Media customer support; or</li>
                        <li>impersonating another user for fraud.</li>
                    </ul>
                </p>
                <p>
                    Parody, fan and commentary accounts may be permitted where they
                    clearly indicate that they are unofficial and do not deceptively
                    misrepresent their identity.
                </p>

                <h2>18. FRAUD AND SCAMS</h2>
                <p>Do not use Bolo-India-Media to cheat or defraud people.</p>
                <p>
                    We prohibit:
                    <ul>
                        <li>phishing;</li>
                        <li>OTP theft;</li>
                        <li>password theft;</li>
                        <li>fake investment schemes;</li>
                        <li>fraudulent loan schemes;</li>
                        <li>fake job offers;</li>
                        <li>impersonation scams;</li>
                        <li>payment fraud;</li>
                        <li>fraudulent giveaways;</li>
                        <li>account theft;</li>
                        <li>financial scams; and</li>
                        <li>
                            other deceptive schemes intended to obtain money, property or
                            confidential information.
                        </li>
                    </ul>
                </p>
                <p>
                    Serious fraud may result in immediate account suspension or
                    termination and actions as per applicable law.
                </p>

                <h2>19. PRIVACY</h2>
                <p>Respect other people's privacy.</p>
                <p>
                    Do not maliciously publish highly sensitive personal information that
                    could expose another person to fraud, identity theft or serious
                    physical harm.
                </p>
                <p>
                    This can include:
                    <ul>
                        <li>passwords;</li>
                        <li>OTPs;</li>
                        <li>financial-account credentials;</li>
                        <li>private identity documents;</li>
                        <li>private medical records;</li>
                        <li>private authentication information; or</li>
                        <li>
                            precise private residential information where disclosure creates a
                            serious safety risk.
                        </li>
                    </ul>
                </p>
                <p>
                    Such serious privacy breach may result in immediate account suspension
                    or termination and actions as per applicable law.
                </p>

                <h2>20. COPYRIGHT</h2>
                <p>Respect the work of creators.</p>
                <p>
                    Do not upload photographs, videos, films, music, artwork or other
                    copyrighted material unless:
                    <ul>
                        <li>you created it;</li>
                        <li>you own the necessary rights;</li>
                        <li>you have permission;</li>
                        <li>you have an appropriate licence; or</li>
                        <li>your use is otherwise legally permitted.</li>
                    </ul>
                </p>
                <p>
                    Giving credit to the original creator does not automatically give you
                    permission to use their work.
                </p>
                <p>
                    Copyright complaints are handled under Bolo India's Copyright & Music
                    Policy.
                </p>

                <h2>21. MUSIC</h2>
                <p>Music may involve several different copyrights and other rights.</p>
                <p>
                    Purchasing a song, subscribing to a music-streaming service or
                    downloading a song does not automatically give you the right to
                    incorporate it into content uploaded to Bolo-India-Media.
                </p>
                <p>
                    Where Bolo-India-Media provides an authorised music library, you may
                    use that music subject to applicable licence conditions and Platform
                    restrictions.
                </p>
                <p>
                    Commercial, advertising and sponsored use may require additional
                    rights.
                </p>
                <p>
                    Bolo-India-Media may mute, restrict or remove music where required
                    because of copyright claims or licensing arrangements.
                </p>

                <h2>22. MOVIES, TELEVISION AND SPORTS</h2>
                <p>
                    Do not upload unauthorised copies or protected portions of:
                    <ul>
                        <li>movies;</li>
                        <li>television programmes;</li>
                        <li>OTT programmes;</li>
                        <li>web series;</li>
                        <li>music videos;</li>
                        <li>sporting broadcasts;</li>
                        <li>concerts; or</li>
                        <li>other copyrighted audiovisual content.</li>
                    </ul>
                </p>
                <p>
                    Recording or screen-recording content from another service does not
                    make that content yours.
                </p>

                <h2>23. SPAM AND FAKE ENGAGEMENT</h2>
                <p>Help us keep Bolo-India-Media authentic.</p>
                <p>
                    DO NOT:
                    <ul>
                        <li>send mass unsolicited messages;</li>
                        <li>operate spam networks;</li>
                        <li>artificially inflate followers;</li>
                        <li>purchase fake engagement;</li>
                        <li>manipulate likes or views;</li>
                        <li>coordinate fake accounts;</li>
                        <li>deploy malicious bots; or</li>
                        <li>attempt to manipulate Platform recommendation systems.</li>
                    </ul>
                </p>
                <p>
                    We may reduce distribution, restrict features, suspend accounts or
                    remove coordinated networks involved in Platform manipulation.
                    Violation may result in immediate account suspension or termination
                    and actions as per applicable law.
                </p>

                <h2>24. DANGEROUS ACTIVITIES</h2>
                <p>
                    Do not encourage people to undertake dangerous activities likely to
                    result in serious injury.
                </p>
                <p>
                    Educational, documentary and safety-related discussion of dangerous
                    activities may be permitted where the context is clear.
                </p>

                <h2>25. SELF-HARM AND SUICIDE</h2>
                <p>
                    We want conversations about mental wellbeing to be supportive rather
                    than harmful.
                </p>
                <p>
                    Content that encourages, glorifies or provides dangerous instructions
                    for suicide or serious self-harm may be removed or restricted.
                    Violation may result in immediate account suspension or termination
                    and actions as per applicable law.
                </p>
                <p>
                    Recovery stories, awareness campaigns, educational discussion and
                    supportive conversations may generally be permitted.
                </p>

                <h2>26. ILLEGAL OR REGULATED GOODS</h2>
                <p>
                    Do not use Bolo-India-Media to unlawfully buy, sell, distribute or
                    facilitate prohibited drugs, weapons or other regulated goods.
                </p>
                <p>
                    Educational, journalistic and harm-prevention discussions are
                    different from unlawful transactions and may be permitted.
                </p>

                <h2>27. ADVERTISING AND COMMERCIAL CONTENT</h2>
                <p>
                    Businesses, advertisers and creators must comply with applicable
                    Indian laws and Bolo-India's advertising policies.
                </p>
                <p>
                    Paid promotions, endorsements, sponsorships and material commercial
                    relationships should be appropriately disclosed where required.
                </p>
                <p>
                    Advertisements must not be fraudulent, deceptive or misleading, cannot
                    contain child sexual abuse material (CSAM), grooming or sexual
                    exploitation of children, pornography, sexually explicit content.
                </p>

                <h2>28. LIVESTREAMING</h2>
                <p>These Community Guidelines apply equally to livestreams.</p>
                <p>
                    Because livestreams happen in real time, Bolo-India-Media may
                    interrupt or terminate a livestream where serious violations are
                    detected.
                </p>
                <p>
                    Repeated violations may result in loss of livestreaming privileges.
                </p>

                <h2>29. DIRECT MESSAGES</h2>
                <p>
                    Where Bolo-India-Media provides direct messaging, users must not use
                    it for:
                    <ul>
                        <li>threats;</li>
                        <li>child grooming;</li>
                        <li>sexual exploitation;</li>
                        <li>scams;</li>
                        <li>fraud;</li>
                        <li>unlawful harassment;</li>
                        <li>spam; or</li>
                        <li>distribution of prohibited content.</li>
                    </ul>
                </p>
                <p>
                    Private communication does not exempt users from applicable law or
                    these Guidelines.
                </p>

                <h2>30. REPORTING CONTENT</h2>
                <p>
                    Every member of Bolo-India-Media can help protect the community. If
                    you see content you believe violates these Guidelines, use:
                </p>
                <p style={{ fontWeight: 700, color: "#1e1e1e" }}>
                    Post / Video / Profile → Options → Report
                </p>
                <p>
                    You may be asked to select a reason such as:
                    <ul>
                        <li>Harassment or Bullying</li>
                        <li>Hate or Abuse</li>
                        <li>Nudity or Sexual Content</li>
                        <li>Child Safety</li>
                        <li>Violence or Threats</li>
                        <li>Fraud or Scam</li>
                        <li>Fake Account / Impersonation</li>
                        <li>Privacy</li>
                        <li>Copyright</li>
                        <li>Spam</li>
                        <li>AI / Deepfake</li>
                        <li>Other</li>
                    </ul>
                </p>
                <p>
                    Reporting content does not automatically mean that it will be removed.
                    We will review the report against our policies and applicable law.
                </p>

                <h2>31. BLOCK, MUTE AND CONTROL YOUR EXPERIENCE</h2>
                <p>
                    Not every unpleasant interaction violates our Community Guidelines.
                </p>
                <p>
                    Bolo-India-Media may provide tools that allow you to:
                    <ul>
                        <li>unfollow;</li>
                        <li>mute;</li>
                        <li>block;</li>
                        <li>restrict comments;</li>
                        <li>limit messages;</li>
                        <li>control who can interact with you; and</li>
                        <li>manage privacy settings.</li>
                    </ul>
                </p>
                <p>
                    We encourage users to use these controls to shape their experience.
                </p>

                <h2>32. WHAT HAPPENS WHEN CONTENT VIOLATES OUR RULES?</h2>
                <p>
                    Depending on the nature and severity of a violation, Bolo-India-Media
                    may:
                    <ul>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>Warn</span> —
                            inform the user about the rule.
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>Label</span> —
                            provide context or safety information.
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Age Restrict
                            </span>{" "}
                            — limit content to eligible users.
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Reduce Distribution
                            </span>{" "}
                            — stop recommending certain content broadly.
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Restrict Features
                            </span>{" "}
                            — temporarily limit comments, messaging, livestreaming or other
                            features.
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Remove Content
                            </span>{" "}
                            — remove a post, video, comment or other content.
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Issue a Strike
                            </span>{" "}
                            — record a violation against the account.
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Suspend Account
                            </span>{" "}
                            — temporarily prevent access.
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Permanently Ban
                            </span>{" "}
                            — terminate an account for serious or repeated violations.
                        </li>
                    </ul>
                </p>
                <p>
                    Serious violations may result in immediate suspension or termination
                    without prior warnings, and actions as per the applicable law.
                </p>

                <h2>33. REPEAT VIOLATIONS</h2>
                <p>
                    Users who repeatedly violate these Guidelines may face increasingly
                    serious enforcement.
                </p>
                <p>
                    Bolo-India-Media may consider:
                    <ul>
                        <li>number of violations;</li>
                        <li>severity;</li>
                        <li>frequency;</li>
                        <li>intent;</li>
                        <li>previous warnings;</li>
                        <li>successful appeals; and</li>
                        <li>risk to other users.</li>
                    </ul>
                </p>
                <p>
                    Repeated serious violations may result in permanent account
                    termination and actions as per applicable law.
                </p>

                <h2>34. APPEAL A DECISION</h2>
                <p>
                    We can make mistakes. If you believe Bolo-India-Media incorrectly
                    removed your content or restricted your account, you may appeal
                    eligible decisions.
                </p>
                <p style={{ fontWeight: 700, color: "#1e1e1e" }}>
                    Where available: Settings → Appeal
                </p>
                <p>Tell us why you believe the decision should be reconsidered.</p>
                <p>Where appropriate, we will conduct another review.</p>
                <p>
                    If the appeal succeeds, we may restore the content and remove the
                    corresponding strike or restriction.
                </p>

                <h2>35. COPYRIGHT APPEALS</h2>
                <p>
                    Copyright complaints and counter-notices are handled separately under
                    our Copyright & Music Policy.
                </p>
                <p>
                    If your content was removed because of a copyright complaint and you
                    believe you own the rights, possess permission or have another lawful
                    basis, you may use the copyright counter-notice/appeal mechanism.
                </p>

                <h2>36. GRIEVANCES</h2>
                <p>
                    Users may contact our Grievance Officer regarding eligible grievances.
                </p>
                <p>
                    Grievance Officer <br />
                    Name: <br />
                    Email:{" "}
                    <a href="mailto:grievances@boloindia.com">grievances@boloindia.com</a>
                </p>
                <p>
                    Complaints will be handled in accordance with applicable Indian law.
                </p>

                <h2>37. GOVERNMENT AND COURT ORDERS</h2>
                <p>
                    Bolo-India-Media may remove or restrict content or provide information
                    where required pursuant to applicable Indian law, a binding court
                    order or other legally valid governmental process.
                </p>
                <p>We review requests through our Legal and Compliance processes.</p>

                <h2>38. CONTEXT MATTERS</h2>
                <p>
                    Before taking action, we may consider the context in which content
                    appears. Content that would ordinarily violate a rule may sometimes
                    have legitimate:
                    <ul>
                        <li>journalistic;</li>
                        <li>documentary;</li>
                        <li>educational;</li>
                        <li>scientific;</li>
                        <li>artistic;</li>
                        <li>satirical;</li>
                        <li>counter speech; or</li>
                        <li>public-interest</li>
                    </ul>
                </p>
                <p>
                    Context does not automatically protect content involving serious
                    exploitation, child sexual abuse or other content that must be removed
                    under applicable law.
                </p>

                <h2>39. OUR COMMITMENT TO FAIR MODERATION</h2>
                <p>
                    We want our rules to be applied consistently. Our moderators and
                    technology may consider:
                    <ul>
                        <li>the content itself;</li>
                        <li>context;</li>
                        <li>target;</li>
                        <li>intent where reasonably ascertainable;</li>
                        <li>severity;</li>
                        <li>likelihood of harm;</li>
                        <li>public-interest considerations;</li>
                        <li>previous violations; and</li>
                        <li>applicable law.</li>
                    </ul>
                </p>
                <p>
                    We may use both automated technology and human review to identify and
                    evaluate potential violations.
                </p>
                <p>
                    Automated systems are not perfect, which is one reason we provide
                    appeal mechanisms for eligible decisions.
                </p>

                <h2>40. COMMUNITY GUIDELINES VS LAW</h2>
                <p>
                    Bolo-India's Community Guidelines may sometimes be stricter than the
                    minimum requirements of law.
                </p>
                <p>
                    This means content may be lawful but still not be suitable for
                    Bolo-India-Media under our Platform policies.
                </p>

                <h2>41. CHANGES TO THESE GUIDELINES</h2>
                <p>
                    Online communities, technology and laws evolve. We may update these
                    Community Guidelines to reflect:
                    <ul>
                        <li>changes in law;</li>
                        <li>regulatory requirements;</li>
                        <li>new Platform features;</li>
                        <li>emerging safety risks;</li>
                        <li>new technologies;</li>
                        <li>AI and synthetic-media developments; or</li>
                        <li>lessons from operating the Bolo-India-Media community.</li>
                    </ul>
                </p>
                <p>
                    Where appropriate or legally required, we will notify users of
                    material changes.
                </p>

                <h2>42. OUR PROMISE TO THE BOLO-INDIA-MEDIA COMMUNITY</h2>
                <p>
                    Bolo-India-Media is built around a simple idea:{" "}
                    <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                        Everyone has a story, and everyone deserves an opportunity to be
                        heard.
                    </span>
                </p>
                <p>But a strong community also requires responsibility.</p>
                <p>
                    We ask every Bolo-India-Media user to:
                    <ul>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Speak freely.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Listen openly.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Disagree respectfully.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Create originally.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Protect people's privacy.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Respect creators.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Protect children.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Don't deceive people.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Don't use your voice to seriously harm others.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                India's strength comes from millions of different voices.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Let those voices be heard responsibly.
                            </span>
                        </li>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Speak. Share. Connect.
                            </span>
                        </li>
                    </ul>
                </p>
                <p style={{ fontWeight: 700, color: "#1e1e1e" }}>Bolo-India.</p>

                <h2>CONTACT US</h2>
                <p>
                    <ul>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Grievance Officer{" "}
                            </span>
                        </li>
                        <p>
                            Email:{" "}
                            <a href="mailto:grievances@boloindia.com">
                                grievances@boloindia.com
                            </a>
                        </p>
                    </ul>
                </p>
                <p>
                    <ul>
                        <li>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Registered Office
                            </span>{" "}
                        </li>
                        <p>
                            <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                                Bolo-India Media Networks Private Limited.
                            </span>{" "}
                            <br />
                            122, Narasimha, C-wing, 3rd Main, Gruhalakshmi layout 2nd stage,
                            Kamalanagar, Bangalore 560079, Karnataka, India.
                        </p>
                    </ul>
                </p>
                <p>
                    <span style={{ fontWeight: 700, color: "#1e1e1e" }}>
                        ©2026 Bolo-India Media Networks Private Limited. All rights
                        reserved.
                    </span>{" "}
                </p>
            </div>

            <LegalLinks />
        </div>
    );
};

export default Media_Community_Policy;
